/* eslint-disable no-param-reassign */
/* eslint-disable new-cap */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import {
  CloseOutlined,
  DeleteOutlined,
  SaveAsOutlined,
} from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PreviewIcon from "@mui/icons-material/Preview";
import { Box } from "@mui/material";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Tree, TreeNode } from "react-organizational-chart";
import { useParams } from "react-router-dom";
import moment from "moment";
import * as Sentry from "@sentry/react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import _ from "lodash";
import Tooltip from "@mui/material/Tooltip";
import Styles from "./ViewOrganogram.styles";
import Appointment from "../../../../services/api/appointment";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import {
  AlertStatus,
  CLOSE_DRAWER_EVENT_NAME,
  OPEN_DRAWER_EVENT_NAME,
  OPEN_SAVE_ALERT_EVENT_NAME,
} from "../../../../contants";
import { isEmptyObj, notNull, toCapitalize } from "../../../../utils/helper";
import DataNotFoundMessage from "../../../../components/DataNotFoundMessage";
import Loader from "../../../../components/common/Loader/Loader";
// import Button from "../../../../components/common/Button";
// import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
// import CheckBox from "../../../../components/common/new/checkBox/CheckBox";
import AddLeader from "./AddLeader/AddLeader";
import AddStructure from "./AddStructure/AddStructure";
import EditLeader from "./EditLeader/EditLeader";
import {
  addNewLeaderNode,
  addNewStrutureNode,
  changeHierarchyInProposedChart,
  createIdForLeader,
  editStrutureNode,
  getLeaderByMemberId,
  removeStrutureByName,
  updateLeaderByMemberId,
} from "./utils";
import Typography from "../../../../components/common/new/Typography/Typography";
import EditStructure from "./EditStructure/EditStructure";
import Alert from "../../../../components/common/new/Alert/Alert";
import Dragdrop from "./Dragdrop";

// const EXTRA_HEIGHT = 500;

// const INITIAL_CHART_TYPE = "before";
// const AFTER_CHART_TYPE = "after";

// const FILTER_OPTIONS = [
//   {
//     value: "before",
//     key: "Before Split",
//   },
//   {
//     value: "after",
//     key: "After Split",
//   },
// ];

const getFileName = (isProposedViewMode) => {
  const filename = isProposedViewMode ? "proposed" : "current";
  return `${filename}-organogram-${new Date().toLocaleDateString()}`;
};

const getTextStyle = (isNew = false, style = {}) =>
  isNew ? { ...style, color: "red" } : style;

function NodeContainer({
  children,
  handleOnClick,
  onHandleAddLeaderClick,
  level2 = false,
  isProposedMode = false,
  isRemoved = false,
  isNew = false,
}) {
  if (isRemoved) {
    return null;
  }

  return (
    <Box
      className={isRemoved ? "organogram-remove-card" : ""}
      style={Styles.root}
    >
      {children}
      {isProposedMode && !level2 && (
        <Box style={Styles.addNewCard}>
          <button
            type="button"
            style={{
              ...Styles.addNewStructureBtn,
              ...(isNew ? Styles.addNewleaderBtn : {}),
            }}
            onClick={handleOnClick}
          >
            +
          </button>
        </Box>
      )}
      {isProposedMode && (
        <button
          type="button"
          style={Styles.addLeaderBtn}
          onClick={onHandleAddLeaderClick}
        >
          + Add Leader
        </button>
      )}
    </Box>
  );
}

// const getName = (name) =>
//   name && `${name.replace(/ /gi, "-")}-${Math.random().toFixed(5)}`;

function InnerContainer({
  summaryNode,
  fixedNode,
  detailNode,
  showExpand,
  forceExpand,
  root,
  onDeleteHandler,
  inputName,
  isProposedMode,
  isRemoved,
  id,
  changeHierarchy,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const handleSummaryClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    if (forceExpand && showExpand) setIsOpen(true);
    else if (!forceExpand) setIsOpen(false);
  }, [forceExpand, showExpand]);

  const onDeleteClick = () => {
    onDeleteHandler(inputName);
  };

  if (isRemoved) {
    return null;
  }

  return (
    <div style={Styles.accordianContainer}>
      <Dragdrop
        draggable={!root && isProposedMode}
        id={id}
        changeHierarchy={changeHierarchy}
      >
        <div style={Styles.summary}>
          {isProposedMode && !root && (
            // <CheckBox
            //   containerStyle={{ margin: 0 }}
            //   checkboxStyle={{ padding: 0 }}
            //   name={getName(inputName)}
            //   handleChange={onChange}
            //   defaultChecked={isRemoved}
            // />
            <DeleteOutlined
              style={{ cursor: "pointer", fontSize: 20 }}
              onClick={() => onDeleteClick(inputName)}
            />
          )}
          {summaryNode}
          {showExpand && (
            <div
              style={isOpen ? Styles.isClosedIcon : Styles.isOpenIcon}
              onClick={handleSummaryClick}
            >
              <ExpandMoreIcon
                style={{
                  color: "#3b3b3b",
                  // color: "#fff",
                }}
              />
            </div>
          )}
        </div>
        {fixedNode}
      </Dragdrop>
      <Box
        style={{
          ...Styles.wrapper,
          ...(isOpen ? Styles.opendetails : {}),
        }}
      >
        <div style={Styles.inner}>{detailNode}</div>
      </Box>
    </div>
  );
}

function DetailNodeGenerator({
  borderColor,
  // inputName,
  onChange,
  // createdBy,
  leaders,
  isProposedMode,
  onEditLeaderClickBtnHandler,
}) {
  return (
    <div style={Styles.detailContainer}>
      <div
        style={{
          ...Styles.titlesContainer,
          borderTop: `1.5px solid ${borderColor}`,
        }}
      >
        {/* OLD CODE - no sorting applied */}
        {/* {leaders?.map((leader) => { */}

        {/* NEW CODE - sorted by division order (MD→WD→YMD→YWD) then Mainline before Deputy */}
        {[...(leaders ?? [])]
          .sort((a, b) => {
            const divOrder = { 1: 0, 2: 1, 37: 2, 3: 3 };
            const divA = divOrder[a.divisionId] ?? 99;
            const divB = divOrder[b.divisionId] ?? 99;
            if (divA !== divB) return divA - divB;
            const isDeputyA = a.positionName?.includes("Deputy") ? 1 : 0;
            const isDeputyB = b.positionName?.includes("Deputy") ? 1 : 0;
            return isDeputyA - isDeputyB;
          })
          .map((leader) => {
            if (leader.isRemoved) return null;

            return (
              <div
                style={Styles.titleText}
                key={leader.memberId}
                className={leader.isRemoved ? "organogram-remove-leader" : ""}
              >
                {/* {isProposedMode && (
                // <CheckBox
                //   containerStyle={{ margin: 0 }}
                //   checkboxStyle={{ padding: 0 }}
                //   name={getName(inputName)}
                //   handleChange={(e) => onChange(e, createIdForLeader(leader))}
                //   defaultChecked={leader.isRemoved}
                // />
               
              )} */}
                <Box display="flex" justifyContent="space-between" flex={1}>
                  <span style={getTextStyle(leader?.isNew)}>
                    {`${notNull(leader?.divisionName)}: ${leader?.memberName}`}
                    <div style={Styles.creadtedTime}>
                      {notNull(leader.positionName)}
                    </div>
                  </span>
                  {isProposedMode && (
                    <Box display="flex" gap="5px">
                      <EditOutlinedIcon
                        fontSize="small"
                        onClick={() =>
                          onEditLeaderClickBtnHandler(createIdForLeader(leader))
                        }
                        style={{ cursor: "pointer", float: "right" }}
                      />
                      <DeleteOutlined
                        style={{ cursor: "pointer", fontSize: 20 }}
                        onClick={() => onChange(createIdForLeader(leader))}
                      />
                    </Box>
                  )}
                </Box>
              </div>
            );
          })}
      </div>
      {/* <div
        style={{
          ...Styles.footerContent,
          borderTop: `1.5px solid ${borderColor}`,
        }}
      >
        Created by -<span style={Styles.createdby}>{notNull(createdBy)}</span>
      </div> */}
    </div>
  );
}

function FixedNodeGenerator({
  borderColor,
  // createdAt,
  // updatedAt,
  totalCount,
  showTotalMembersCount = true,
  isSubChild = false,
  totalMembersCount,
  label,
  isNew = false,
}) {
  return (
    <div
      style={{
        ...Styles.fixedContainer,
        borderTop: `1.5px solid ${borderColor}`,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        color={isNew ? "red" : "black"}
      >
        {showTotalMembersCount && (
          <div style={Styles.fixedNodeHeading}>
            Total {label} - {totalCount}
          </div>
        )}
        {!isSubChild && (
          <div style={Styles.fixedNodeHeading}>
            Total Members - {totalMembersCount}
          </div>
        )}
      </Box>

      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={Styles.creadtedTime}>
          Created On: {moment(createdAt).format("DD MMM YYYY")}
        </div>
        <div style={Styles.creadtedTime}>
          Last Edit : {moment(updatedAt).format("DD MMM YYYY")}
        </div>
      </div> */}
    </div>
  );
}

function ViewOrganogram() {
  const [originalChartData, setOriginalChartData] = useState(null);
  const [proposedChartData, setProposedChartData] = useState(null);
  // const [chartType, setChartType] = useState(INITIAL_CHART_TYPE);
  const [notFound, setNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isExpandAll, setIsExpandAll] = useState(false);
  const [isFullScreenView, setIsFullScreenView] = useState(false);
  const [isProposedMode, setIsProposedMode] = useState(false);
  const [isProposedViewMode, setIsProposedViewMode] = useState(false);
  const [selectedStructureName, setSelectedStructureName] = useState(null);
  const [selectedLeader, setSelectedLeader] = useState(null);
  const [selectedStructure, setSelectedStructure] = useState(null);
  const [chartDataResponse, setChartDataResponse] = useState(null);

  // Modals
  const [openEditLeaderModal, setOpenEditLeaderModal] = useState(false);
  const [openAddLeaderModal, setOpenAddLeaderModal] = useState(false);
  const [openAddStrutureModal, setOpenAddStrutureModal] = useState(false);
  const [openEditStrutureModal, setOpenEditStrutureModal] = useState(false);
  const [openSaveAlert, setOpenSaveAlert] = useState(false);

  const alert = useContext(ToastAlertContext);
  const { id } = useParams();
  const pdfRef = useRef(null);

  const date = moment();
  const currentDate = date.format("DD/MM/YYYY");

  const getProposedChartData = (data) => {
    if (
      data?.proposedOrganogram &&
      !isEmptyObj(data?.proposedOrganogram?.parent)
    ) {
      return data?.proposedOrganogram;
    }
    return data?.additionalInfo ?? data;
  };

  const fetchChartData = async () => {
    try {
      setNotFound(false);
      const api = Appointment.getOrganogramByStructureId;
      // isBeforePresent.current && type === INITIAL_CHART_TYPE
      //   ? Appointment.getBeforeSplitStructure
      //   : Appointment.getAfterSplitStructure;

      const { data } = await api(Number(id));

      setOriginalChartData(data.additionalInfo ?? data);
      setProposedChartData(getProposedChartData(data));
      setChartDataResponse(data);
    } catch (error) {
      if (error.status === 404) {
        setNotFound(true);
      }
      setOriginalChartData(null);
      setProposedChartData(null);
      alert.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
      // setChartType(
      //   isBeforePresent.current && type === INITIAL_CHART_TYPE
      //     ? INITIAL_CHART_TYPE
      //     : AFTER_CHART_TYPE
      // );
    }
  };

  // const onFilterChange = (e) => {
  //   const { value } = e.target;
  //   setChartType(value);
  //   fetchChartData(value);
  // };

  useEffect(() => {
    if (id) {
      fetchChartData();
    }
  }, [id]);

  const openFullscreen = () => {
    const elem = document.getElementById("organogram-chart");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
    setIsFullScreenView(true);
  };

  /* Close fullscreen */
  const closeFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
    setIsFullScreenView(false);
  };
  // due to shrink pdf
  // const exportPDF = (canvas, exportFilename) => {
  //   const canvasWidth = Math.ceil(canvas.width);
  //   const canvasHeight = Math.ceil(canvas.height);
  //   const doc =
  //     canvasWidth > canvasHeight
  //       ? new jsPDF({
  //           orientation: "landscape",
  //           unit: "px",
  //           format: [canvasWidth, canvasHeight],
  //         })
  //       : new jsPDF({
  //           orientation: "portrait",
  //           unit: "px",
  //           format: [canvasHeight, canvasWidth],
  //         });
  //   doc.setFontSize(50);
  //   doc.text(
  //     isProposedViewMode ? "Proposed Organogram" : "Current Organogram",
  //     300,
  //     50,
  //     { align: "center" }
  //   );
  //   doc.addImage(canvas.toDataURL("image/jpeg", 1.0), "JPEG", 100, 100);
  //   doc.save(`${exportFilename}.pdf`);
  // };

  const exportPDF = (canvas, exportFilename) => {
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const margin = 10;

    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    const ratio = Math.min(
      (pageWidth - margin * 2) / imgWidth,
      (pageHeight - margin * 2) / imgHeight
    );

    const pdfWidth = imgWidth * ratio;
    const pdfHeight = imgHeight * ratio;

    pdf.addImage(
      imgData,
      "PNG",
      (pageWidth - pdfWidth) / 2,
      (pageHeight - pdfHeight) / 2,
      pdfWidth,
      pdfHeight
    );

    pdf.save(`${exportFilename}.pdf`);
  };
  const exportTo = () => {
    setIsDownloading(true);
    const originalScrollLeft = pdfRef.current.scrollLeft;
    pdfRef.current.scrollLeft = 0;
    const originalScrollTop = pdfRef.current.scrollTop;
    pdfRef.current.scrollTop = 0;
    const chartRef2 = document.querySelector(".orgchart");
    html2canvas(chartRef2, {
      scale: 2,
      width: chartRef2.scrollWidth,
      height: chartRef2.scrollHeight,
      scrollX: 0,
      scrollY: 0,
    }).then(
      (canvas) => {
        exportPDF(canvas, getFileName(isProposedViewMode));
        setIsDownloading(false);
        pdfRef.current.scrollLeft = originalScrollLeft;
        pdfRef.current.scrollTop = originalScrollTop;
      },
      () => {
        setIsDownloading(false);
        pdfRef.current.scrollLeft = originalScrollLeft;
        pdfRef.current.scrollTop = originalScrollTop;
      }
    );
  };

  const toggleExpand = () => setIsExpandAll((prev) => !prev);

  // const toggleExpand = () => setIsExpandAll((prev) => !prev);
  const toggleEditLeaderModal = () => setOpenEditLeaderModal((prev) => !prev);
  const toggleAddLeaderModal = () => setOpenAddLeaderModal((prev) => !prev);
  const toggleProposedHandler = () => setIsProposedMode((prev) => !prev);
  const toggleProposedViewHandler = () =>
    setIsProposedViewMode((prev) => !prev);
  const toggleEditStructureModal = () =>
    setOpenEditStrutureModal((prev) => !prev);
  const toggleAddStructureModal = () =>
    setOpenAddStrutureModal((prev) => !prev);

  const submitProposedChart = async () => {
    try {
      const { data } = await Appointment.submitProposedOrganogramByStructureId(
        id,
        proposedChartData
      );

      setProposedChartData(data.proposedOrganogram ?? {});
      setChartDataResponse((prev) => ({
        ...prev,
        proposedOrganogram: data.proposedOrganogram ?? {},
      }));
      alert.show("Submitted Successfully", AlertStatus.SUCCESS);
      toggleProposedHandler();
    } catch (error) {
      console.error(error.message);
      alert.show(error.message, AlertStatus.ERROR);
    }
  };

  const onAddStructure = ({ structureName }) => {
    setProposedChartData((prevProposedChartData) => {
      return addNewStrutureNode(
        prevProposedChartData,
        structureName,
        selectedStructureName
      );
    });
    toggleAddStructureModal();
  };

  const onEditStructure = (updatedFields) => {
    setProposedChartData((prevProposedChartData) => {
      return editStrutureNode(
        prevProposedChartData,
        updatedFields,
        selectedStructure.structureName
      );
    });
    toggleEditStructureModal();
  };

  const onDeleteStructureHandler = (structureName) => {
    setProposedChartData((prevProposedChartData) => {
      return removeStrutureByName(prevProposedChartData, structureName, true);
    });
  };

  // eslint-disable-next-line no-shadow
  const onDeleteLeaderHandler = (id) => {
    setProposedChartData((prevProposedChartData) => {
      return updateLeaderByMemberId(prevProposedChartData, id, {
        isRemoved: true,
      });
    });
  };

  const onAddLeader = (formValues) => {
    setProposedChartData((prevProposedChartData) => {
      return addNewLeaderNode(
        prevProposedChartData,
        formValues,
        selectedStructureName
      );
    });
    toggleAddLeaderModal();
  };

  // eslint-disable-next-line no-shadow
  const onEditLeader = (formValues, id) => {
    setProposedChartData((prevProposedChartData) => {
      return updateLeaderByMemberId(prevProposedChartData, id, formValues);
    });
    toggleEditLeaderModal();
  };

  const onAddStructureClickBtnHandler = (name) => {
    setSelectedStructureName(name);
    toggleAddStructureModal();
  };

  const onAddLeaderClickBtnHandler = (name) => {
    setSelectedStructureName(name);
    toggleAddLeaderModal();
  };

  // eslint-disable-next-line no-shadow
  const onEditLeaderClickBtnHandler = (id) => {
    setSelectedLeader(() => getLeaderByMemberId(proposedChartData, id));
    toggleEditLeaderModal();
  };

  // eslint-disable-next-line no-shadow
  const onEditStructureClickBtnHandler = (structure) => {
    setSelectedStructure(structure);
    toggleEditStructureModal();
  };

  const isShowExpand = (leaders) => {
    if (!leaders || !leaders.length) return false;

    return leaders.some((leader) => !leader?.isRemoved);
  };

  const onSaveAlertClose = () => {
    setProposedChartData(getProposedChartData(chartDataResponse));
    setOpenSaveAlert(false);
    toggleProposedHandler();
  };

  const onSaveAlertSubmit = () => {
    submitProposedChart();
    setOpenSaveAlert(false);
  };

  const clearProposedChart = () => {
    setProposedChartData(getProposedChartData(chartDataResponse));
  };

  const chartData = useMemo(() => {
    if (isProposedViewMode) return getProposedChartData(chartDataResponse);

    return isProposedMode ? proposedChartData : originalChartData;
  }, [
    isProposedMode,
    isProposedViewMode,
    proposedChartData,
    originalChartData,
    chartDataResponse,
  ]);

  const enableSaveButton = useMemo(
    () =>
      !_.isEqual(getProposedChartData(chartDataResponse), proposedChartData),
    [proposedChartData, chartDataResponse]
  );

  const showExpandButton = !!(chartData && chartData.parent);
  const ExpandCollapseIcon = !isExpandAll
    ? OpenInFullIcon
    : CloseFullscreenIcon;

  const openSaveAlertHandler = () => {
    if (isProposedMode && enableSaveButton) {
      setOpenSaveAlert(true);
    }
  };

  const changeHierarchy = (originId, destionationId) => {
    setProposedChartData((prevProposedChartData) =>
      changeHierarchyInProposedChart(
        prevProposedChartData,
        originId,
        destionationId
      )
    );
  };

  useEffect(() => {
    document.addEventListener(OPEN_SAVE_ALERT_EVENT_NAME, openSaveAlertHandler);
    return () => {
      document.removeEventListener(
        OPEN_SAVE_ALERT_EVENT_NAME,
        openSaveAlertHandler
      );
    };
  }, [openSaveAlertHandler]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Box id="organogram-chart" style={Styles.container}>
      <Box style={Styles.organogramDate}>
        <div />
        <Typography fontSize="18px" weight={500} mr="16px">
          {isProposedMode || isProposedViewMode ? (
            <div>
              Proposed Organogram:
              {chartDataResponse && chartDataResponse.updatedAt
                ? moment(chartDataResponse.updatedAt).format(" DD/MM/YYYY")
                : currentDate}
            </div>
          ) : (
            <div>Current Organogram: {currentDate}</div>
          )}
        </Typography>

        <Typography justifySelf="end" fontSize="18px" weight={500} mr="16px">
          {chartDataResponse &&
            chartDataResponse.updatedByName &&
            `Last updated by ${chartDataResponse.updatedByName}`}
        </Typography>
      </Box>
      <Box style={Styles.subHeader}>
        <Box style={Styles.filter}>
          {isProposedViewMode && (
            <Tooltip title="Back">
              <ArrowBackIcon
                style={Styles.icon}
                onClick={toggleProposedViewHandler}
              />
            </Tooltip>
          )}
          {isFullScreenView ? (
            <Tooltip title="Full Screen Exit">
              <FullscreenExitIcon
                style={Styles.icon}
                onClick={closeFullscreen}
              />
            </Tooltip>
          ) : (
            <Tooltip title="Full Screen">
              <FullscreenIcon style={Styles.icon} onClick={openFullscreen} />
            </Tooltip>
          )}
          {isExpandAll && !isProposedMode && (
            <Tooltip title="Download">
              <DownloadIcon
                style={{
                  ...Styles.icon,
                  ...(isDownloading ? Styles.download : {}),
                }}
                onClick={exportTo}
              />
            </Tooltip>
          )}
          {showExpandButton && (
            <Tooltip title={isExpandAll ? "Collapse" : "Expand"}>
              <ExpandCollapseIcon style={Styles.icon} onClick={toggleExpand} />
            </Tooltip>
          )}
          {/* <Dropdown
            name="chartType"
            value={chartType}
            options={FILTER_OPTIONS}
            onChange={onFilterChange}
            disabled={!isBeforePresent.current}
            containerStyle={{ display: !isBeforePresent.current ? "none" : "block", minWidth: 130, width: 'max-content' }}
          /> */}
          {!isProposedMode && !isProposedViewMode && (
            <Tooltip title="Proposed Preview">
              <PreviewIcon
                style={Styles.icon}
                onClick={toggleProposedViewHandler}
              />
            </Tooltip>
          )}
          {!isProposedMode ? (
            <Tooltip title="Edit">
              <EditOutlinedIcon
                style={Styles.icon}
                onClick={() => {
                  toggleProposedHandler();
                  document.dispatchEvent(new Event(CLOSE_DRAWER_EVENT_NAME));
                }}
              />
            </Tooltip>
          ) : (
            <Tooltip title="Close">
              <CloseOutlined
                style={Styles.icon}
                onClick={() => {
                  if (enableSaveButton) {
                    setOpenSaveAlert(true);
                  } else {
                    toggleProposedHandler();
                  }
                  document.dispatchEvent(new Event(OPEN_DRAWER_EVENT_NAME));
                }}
              />
            </Tooltip>
          )}
          {isProposedMode && (
            <Tooltip title="Clear">
              <DeleteForeverOutlinedIcon
                onClick={clearProposedChart}
                style={Styles.icon}
              />
            </Tooltip>
          )}
          {isProposedMode && (
            <Tooltip title="Save">
              <SaveAsOutlined
                style={{
                  ...Styles.icon,
                  ...(!enableSaveButton ? Styles.disableIcon : {}),
                }}
                onClick={enableSaveButton && submitProposedChart}
              />
            </Tooltip>
          )}
        </Box>
      </Box>
      <Box style={Styles.container} ref={pdfRef}>
        {!notFound && chartData && chartData.parent ? (
          <Box className="orgchart">
            <Tree
              lineWidth="2px"
              lineColor="#707070"
              lineBorderRadius="4px"
              nodePadding="10px"
              label={
                <NodeContainer
                  isRoot
                  isProposedMode={isProposedMode}
                  isRemoved={!!chartData?.parent?.isRemoved}
                  onHandleAddLeaderClick={() => {
                    onAddLeaderClickBtnHandler(chartData.parent?.structureName);
                  }}
                  handleOnClick={() =>
                    onAddStructureClickBtnHandler(
                      chartData.parent?.structureName
                    )
                  }
                >
                  <InnerContainer
                    root
                    showExpand={isShowExpand(chartData?.parent?.leaders)}
                    forceExpand={isExpandAll}
                    fixedNode={
                      <FixedNodeGenerator
                        borderColor="#3b3b3b"
                        createdAt={notNull(chartData?.parent?.createdAt)}
                        updatedAt={notNull(chartData?.parent?.updatedAt)}
                        showTotalMembersCount={false}
                        totalMembersCount={notNull(
                          chartData?.parent?.totalMembersCount
                        )}
                        label="Districts"
                        isNew={!!chartData?.present?.isNew}
                      />
                    }
                    inputName={notNull(chartData?.parent?.structureName)}
                    onDeleteHandler={onDeleteStructureHandler}
                    isProposedMode={isProposedMode}
                    isRemoved={!!chartData.parent?.isRemoved}
                    summaryNode={
                      <>
                        {chartData.parentStructure === "NATIONAL" ? (
                          <div
                            style={getTextStyle(
                              !!chartData?.present?.isNew,
                              Styles.rootheading
                            )}
                          >
                            {notNull(toCapitalize(chartData.parentStructure))}
                          </div>
                        ) : (
                          <div
                            style={getTextStyle(
                              !!chartData?.present?.isNew,
                              Styles.rootheading
                            )}
                          >
                            {notNull(toCapitalize(chartData.parentStructure))} -{" "}
                            {notNull(chartData.parent.structureName)}
                          </div>
                        )}
                        {isProposedMode && (
                          <EditOutlinedIcon
                            style={Styles.editIcon}
                            onClick={() =>
                              onEditStructureClickBtnHandler(chartData.parent)
                            }
                          />
                        )}
                      </>
                    }
                    detailNode={
                      <DetailNodeGenerator
                        borderColor="#3b3b3b"
                        leaders={notNull(chartData?.parent?.leaders)}
                        createdBy={notNull(chartData?.createdBy?.memberName)}
                        onChange={onDeleteLeaderHandler}
                        isProposedMode={isProposedMode}
                        onEditLeaderClickBtnHandler={
                          onEditLeaderClickBtnHandler
                        }
                      />
                    }
                  />
                </NodeContainer>
              }
            >
              {chartData?.children?.length > 0 &&
                chartData.children.map(
                  ({
                    child,
                    subChildren,
                    isNew = false,
                    isRemoved = false,
                  }) => (
                    <TreeNode
                      label={
                        <NodeContainer
                          level1
                          handleOnClick={() =>
                            onAddStructureClickBtnHandler(child?.structureName)
                          }
                          onHandleAddLeaderClick={() => {
                            onAddLeaderClickBtnHandler(child?.structureName);
                          }}
                          isProposedMode={isProposedMode}
                          isRemoved={isRemoved}
                          isNew={isNew}
                        >
                          <InnerContainer
                            level1
                            showExpand={isShowExpand(child?.leaders)}
                            forceExpand={isExpandAll}
                            fixedNode={
                              <FixedNodeGenerator
                                borderColor="#3b3b3b"
                                createdAt={notNull(child?.createdAt)}
                                updatedAt={notNull(child?.updatedAt)}
                                totalCount={notNull(subChildren?.length)}
                                totalMembersCount={notNull(
                                  child?.totalMembersCount
                                )}
                                label={toCapitalize(
                                  chartData.subChildStructure
                                )}
                                isNew={isNew}
                              />
                            }
                            inputName={child?.structureName}
                            onDeleteHandler={onDeleteStructureHandler}
                            isProposedMode={isProposedMode}
                            isRemoved={isRemoved}
                            id={`child-${notNull(child?.structureName)}`}
                            changeHierarchy={changeHierarchy}
                            summaryNode={
                              <div
                                style={getTextStyle(
                                  isNew,
                                  Styles.level1summaryHeading
                                )}
                                className="struture-name"
                              >
                                {notNull(
                                  toCapitalize(chartData?.childStructure)
                                )}{" "}
                                - {notNull(child?.structureName)}
                                {isProposedMode && (
                                  <EditOutlinedIcon
                                    style={Styles.editIcon}
                                    onClick={() =>
                                      onEditStructureClickBtnHandler(child)
                                    }
                                  />
                                )}
                              </div>
                            }
                            detailNode={
                              <DetailNodeGenerator
                                borderColor="#3b3b3b"
                                leaders={child?.leaders}
                                createdBy={child?.createdBy?.memberName}
                                onChange={onDeleteLeaderHandler}
                                isProposedMode={isProposedMode}
                                onEditLeaderClickBtnHandler={
                                  onEditLeaderClickBtnHandler
                                }
                              />
                            }
                          />
                        </NodeContainer>
                      }
                    >
                      {subChildren?.length > 0
                        ? subChildren.map((subChild) => (
                            <TreeNode
                              key={`${subChild?.createdAt}-${subChild?.structureName}`}
                              label={
                                <NodeContainer
                                  isRemoved={!!subChild?.isRemoved}
                                  isNew={!!subChild?.isNew}
                                  isProposedMode={isProposedMode}
                                  onHandleAddLeaderClick={() => {
                                    onAddLeaderClickBtnHandler(
                                      subChild?.structureName
                                    );
                                  }}
                                  level2
                                >
                                  <InnerContainer
                                    showExpand={isShowExpand(subChild?.leaders)}
                                    forceExpand={isExpandAll}
                                    fixedNode={
                                      <FixedNodeGenerator
                                        borderColor="#3b3b3b"
                                        createdAt={subChild?.createdAt}
                                        updatedAt={subChild?.updatedAt}
                                        totalCount={subChild?.totalMembersCount}
                                        isNew={!!subChild?.isNew}
                                        // showTotalMembersCount={
                                        //   chartData.subChildStructure === "BLOCK"
                                        // }
                                        showTotalMembersCount={
                                          chartData?.subChildStructure ===
                                            "AREA" ||
                                          chartData?.subChildStructure ===
                                            "ZONE" ||
                                          chartData?.subChildStructure ===
                                            "REGION" ||
                                          chartData?.subChildStructure ===
                                            "CHAPTER" ||
                                          chartData?.subChildStructure ===
                                            "DISTRICT" ||
                                          chartData?.subChildStructure ===
                                            "BLOCK"
                                        }
                                        label="Members"
                                        isSubChild
                                      />
                                    }
                                    inputName={subChild?.structureName}
                                    onDeleteHandler={onDeleteStructureHandler}
                                    isProposedMode={isProposedMode}
                                    isRemoved={!!subChild?.isRemoved}
                                    id={`subChild-${notNull(
                                      subChild?.structureName
                                    )}`}
                                    changeHierarchy={changeHierarchy}
                                    summaryNode={
                                      <div
                                        style={getTextStyle(
                                          !!subChild.isNew,
                                          Styles.level2summaryHeading
                                        )}
                                        className="struture-name"
                                      >
                                        {notNull(
                                          toCapitalize(
                                            chartData?.subChildStructure
                                          )
                                        )}{" "}
                                        - {notNull(subChild.structureName)}
                                        {isProposedMode && (
                                          <EditOutlinedIcon
                                            style={Styles.editIcon}
                                            onClick={() =>
                                              onEditStructureClickBtnHandler(
                                                subChild
                                              )
                                            }
                                          />
                                        )}
                                      </div>
                                    }
                                    detailNode={
                                      <DetailNodeGenerator
                                        borderColor="#3b3b3b"
                                        leaders={subChild?.leaders}
                                        createdBy={
                                          subChild?.createdBy?.memberName
                                        }
                                        onChange={onDeleteLeaderHandler}
                                        isProposedMode={isProposedMode}
                                        onEditLeaderClickBtnHandler={
                                          onEditLeaderClickBtnHandler
                                        }
                                      />
                                    }
                                  />
                                </NodeContainer>
                              }
                            />
                          ))
                        : null}
                    </TreeNode>
                  )
                )}
            </Tree>
          </Box>
        ) : (
          <DataNotFoundMessage />
        )}
      </Box>
      <AddLeader
        open={openAddLeaderModal}
        onClose={toggleAddLeaderModal}
        onFormSubmit={onAddLeader}
      />
      <EditLeader
        open={openEditLeaderModal}
        onClose={toggleEditLeaderModal}
        selectedLeader={selectedLeader}
        onFormSubmit={onEditLeader}
      />
      <AddStructure
        open={openAddStrutureModal}
        onClose={toggleAddStructureModal}
        onFormSubmit={onAddStructure}
      />
      <EditStructure
        open={openEditStrutureModal}
        onClose={toggleEditStructureModal}
        onFormSubmit={onEditStructure}
        selectedStructure={selectedStructure}
      />
      <Alert
        open={openSaveAlert}
        onClose={onSaveAlertClose}
        onSubmit={onSaveAlertSubmit}
        text="Do you wish to save the changes?"
      />
    </Box>
  );
}

export default ViewOrganogram;
